import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import VTFindClub from "../page/VTFindClub";

/**
 * Checkin Venue / Find Club
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingFindClub() {
    return (
        <>
            <Header/>
            <VTFindClub/>
            <Footer/>
        </>
    );
}